import React, { CSSProperties, FC } from 'react';
import classNames from 'classnames';
import classes from './styles/roundedContainer.module.scss';
import { PaddingBox } from '../PaddingBox';

type RoundedContainerProps = {
	id?: string;
	className?: string;
	noPadding?: boolean;
	dataTestId?: string;
	style?: CSSProperties;
};

export const RoundedContainer: FC<React.PropsWithChildren<RoundedContainerProps>> = ({
	className,
	children,
	noPadding,
	dataTestId,
	id,
	style,
}) => {
	const containerClassNames = classNames(className, classes.roundedContainer);
	return (
		<div
			id={id}
			className={containerClassNames}
			data-testid={dataTestId}
			style={style}
		>
			{noPadding && children}
			{!noPadding && <PaddingBox small>{children}</PaddingBox>}
		</div>
	);
};
